<script>
  const ALLOWED_VALUES = ["free", "private"];

  export default {
    props: ["policy", "user"],
    data() {
      return {
        options: ALLOWED_VALUES.map((value) => ({
          value,
          label: value.charAt(0).toUpperCase() + value.slice(1),
        })),
        selectedOptions: [],
        isBootstrapped: false,
      };
    },
    created() {
      const hasInitialSelection = this.syncSelectionFromSources();

      this.$nextTick(() => {
        this.isBootstrapped = true;

        if (hasInitialSelection) {
          this.emitSelectionIfNeeded();
        }
      });
    },
    methods: {
      syncSelectionFromSources() {
        const incoming = this.normalizeSelection(this.collectAllowedRegisters());

        if (!this.areSelectionsEqual(this.selectedOptions, incoming)) {
          this.selectedOptions = incoming;
        }

        return incoming.length > 0;
      },
      collectAllowedRegisters() {
        const registerPolicy = this.user?.polices?.["assign-permission-free-private"];
        const sources = [this.policy?.allowedRegisters, this.policy?.payload, this.policy?.value, registerPolicy?.allowedRegisters, registerPolicy?.payload];

        for (const candidate of sources) {
          const extracted = this.extractAllowedRegisters(candidate);

          if (extracted.length) {
            return extracted;
          }
        }

        return [];
      },
      extractAllowedRegisters(source) {
        if (!source) {
          return [];
        }

        if (Array.isArray(source)) {
          return [...source];
        }

        if (typeof source === "string") {
          return [source];
        }

        if (typeof source === "object") {
          if (Array.isArray(source.allowedRegisters)) {
            return [...source.allowedRegisters];
          }

          return Object.keys(source).filter((key) => source[key]);
        }

        return [];
      },
      normalizeSelection(list = []) {
        const normalized = list
          .map((option) =>
            String(option)
              .trim()
              .toLowerCase()
          )
          .filter((option) => ALLOWED_VALUES.includes(option));

        const unique = new Set(normalized);
        return ALLOWED_VALUES.filter((value) => unique.has(value));
      },
      emitSelectionIfNeeded() {
        const normalized = this.normalizeSelection(this.selectedOptions);

        if (!this.areSelectionsEqual(this.selectedOptions, normalized)) {
          this.selectedOptions = normalized;
          return;
        }

        this.$emit("result-updated", { politic: { allowedRegisters: normalized } });
      },
      areSelectionsEqual(a = [], b = []) {
        if (a.length !== b.length) {
          return false;
        }

        return a.every((value, index) => value === b[index]);
      },
    },
    watch: {
      selectedOptions: {
        handler() {
          if (!this.isBootstrapped) {
            return;
          }

          this.emitSelectionIfNeeded();
        },
        deep: true,
      },
      user: {
        handler() {
          this.syncSelectionFromSources();
        },
        deep: true,
      },
      policy: {
        handler() {
          this.syncSelectionFromSources();
        },
        deep: true,
      },
    },
  };
</script>

<template>
  <section class="policy-register">
    <label v-for="option in options" :key="option.value" class="policy-register__option">
      <input class="policy-register__input" type="checkbox" :value="option.value" v-model="selectedOptions" />
      <span class="policy-register__txt">{{ option.label }}</span>
    </label>
  </section>
</template>

<style lang="scss" scoped>
  .policy-register {
    @include Flex();
    width: fit-content;
    gap: 20px;

    &__option {
      @include Flex(row, center, center);
      gap: 8px;
      font-weight: bold;
      cursor: pointer;
    }

    &__input {
      cursor: pointer;
      accent-color: $primary-color;
    }

    &__txt {
      font-size: 16px;
    }
  }
</style>
